/*
 * @Description: 门户管理
 */
import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/pcHome.vue'
const computerRouter: Array<RouteRecordRaw> = [
    {
        path: '/computer',
        component: Layout,
        redirect: '/computer/construction/pageList',
        children: [
          {
            path: 'construction',
            component: () => import(/* webpackChunkName: "Construction" */ '@/views/computerPage/construction.vue'),
            name: 'Construction',
            redirect:'/computer/construction/pageList',
            meta: { title: '' },
            children:[
              {
                path: 'pageList',
                component: () => import(/* webpackChunkName: "pageList" */ '@/views/computerPage/pageList/index.vue'),
                name: 'Pagelist',
                meta: { title: '门户微页面' }
              },
              {
                path: 'navBarSetting',
                component: () => import(/* webpackChunkName: "navBarSetting" */ '@/views/computerPage/navigation/index.vue'),
                name: 'NavBarSetting',
                meta: { title: '导航设置' }
              },
              {
                path: 'footerSetting',
                component: () => import(/* webpackChunkName: "footerSetting" */ '@/views/computerPage/footer/index.vue'),
                name: 'FooterSetting',
                meta: { title: '页脚设置' }
              },
              {
                path: 'pageStyle',
                component: () => import(/* webpackChunkName: "pageStyle" */ '@/views/computerPage/pageStyle/index.vue'),
                name: 'PageStyle',
                meta: { title: '风格与其他' }
              },
            ]
          },
          {
            path: 'material',
            component: () => import(/* webpackChunkName: "Material" */ '@/views/computerPage/material.vue'),
            name: 'Material',
            redirect:'/computer/material/essayManage',
            meta: { title: '' },
            children:[
              {
                path: 'essayManage',
                name: 'EssayManage',
                meta: { title: '素材管理' },
                component: () => import(/* webpackChunkName: "EssayManage" */ '@/views/computerPage/materialManage/EssayManage/index.vue'),
              },
              {
                path: 'createEssay',
                name: 'CreateEssay',
                meta: { title: '文章详情' },
                component: () => import(/* webpackChunkName: "CreateEssay" */ '@/views/computerPage/materialManage/EssayManage/CreateEssay.vue'),
              },
            ]
          }
        ]
      }
      
]

export default computerRouter
